<template src="./FinancialExtract.html" />
<script>
import mixins from "@/Mixins.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      showWebTable: true,
      extracts: [],
      periodSelected: { text: "Mais recente", value: 0 },
      periods: [
        { text: "Mais recente", value: 0 },
        { text: "15 dias", value: 15 },
        { text: "30 dias", value: 30 },
        { text: "120 dias", value: 120 }
      ],
      overview: [],
      avaliableBalance: ""
    }
  },
  created () {
    const vm = this
    window.addEventListener("resize", vm.handleResize)
    vm.handleResize()
  },
  destroyed () {
    const vm = this
    window.removeEventListener("resize", vm.handleResize)
  },
  mounted: function () {
    const vm = this
    vm.init()
  },
  watch: {
    periodSelected: function (newVal) {
      const vm = this
      if (vm.testNullUndefinedEmpty(newVal)) {
        vm.periodSelected = { text: "Mais recente", value: 0 }
      }
      vm.getWalletTransactionsPeriod()
    }
  },
  methods: {
    init () {
      const vm = this
      vm.getWalletTransactionsPeriod()
      vm.getWalletOverview()
    },
    handleResize () {
      const vm = this
      vm.window.width = window.innerWidth
      vm.window.height = window.innerHeight
      if (vm.window.width < 665) {
        vm.showWebTable = false
      } else {
        vm.showWebTable = true
      }
    },
    getWalletOverview () {
      const vm = this
      this.axios
        .get(vm.$store.state.filooServer + "wallet/overview", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.overview = response.data
            vm.fillInData(vm.overview)
          }
        })
    },
    fillInData (overview) {
      const vm = this
      vm.avaliableBalance = vm.maskMoney(overview.avaliableBalance)
    },
    getWalletTransactionsPeriod () {
      const vm = this
      this.axios
        .get(
          vm.$store.state.filooServer +
          "wallet/transactions/period/" +
          vm.periodSelected.value,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function (response) {
          vm.extracts = response.data.content
        })
    },
    getDay (dateHour) {
      return dateHour.substring(0, 10)
    },
    maskMoney (value) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      })
      var newValue = parseFloat(value)

      var newValueFormat = formatter.format(newValue)

      return newValueFormat
    }
  }
}
</script>
<style lang="scss" src="./FinancialExtract.scss"></style>